import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { GrowlModule, MessagesModule, MessageModule, CalendarModule } from 'primeng/primeng';
import { DataTablesModule } from 'angular-datatables';
import { FooterComponent } from '../headerandnavigation/footer/footer.component';
import { FCSMediaComponent } from '../home/fcsmedia.component';
import { RssNewsFeedComponent } from '../home/rssnewsfeed.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { RouterModule } from '@angular/router';
import { BlogsComponent } from '../blogs/blogs.component';
import { RssNewsFeedDetailsComponent } from '../home/rssnewsfeeddetails.component';
import { RelatedDriverNewsComponent } from '../home/relateddrivernews.component';
import { InputCounterModule } from 'ng4-input-counter';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        GrowlModule,MessagesModule,MessageModule,DataTablesModule,
        CalendarModule,
        NgxPaginationModule,
        InputCounterModule.forRoot(),
        RouterModule.forChild([
          { path: 'drivingnews/:slug', component: RssNewsFeedDetailsComponent },
          { path: 'drivingnews/:slug/:category', component: RssNewsFeedDetailsComponent }
        ])
    ],
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        GrowlModule,MessagesModule,MessageModule,DataTablesModule,
        CalendarModule,
        FooterComponent,
        FCSMediaComponent,
        RssNewsFeedComponent,
        NgxPaginationModule,
        InputCounterModule
    ],
    declarations: [
      FooterComponent,
      FCSMediaComponent,
      RssNewsFeedComponent,
      RssNewsFeedDetailsComponent,
      RelatedDriverNewsComponent
    ],
    providers: [
        
    ]
})
export class SharedModule { }



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts